import React, { useCallback, useState } from 'react';

import { SnackBar } from '@swyftx/aviary/atoms/Snackbar/Snackbar';

import { useSnackBars } from './useSnackBars';

const GlobalSnackBars: React.FC = () => {
  const { snackbars, removeSnackBar } = useSnackBars();
  const [closedSnackbars, setClosedSnackbars] = useState<Map<string, boolean>>(new Map());

  const handleClose = useCallback(
    (uuid: string) => {
      setClosedSnackbars(new Map(closedSnackbars.set(uuid, true)));

      setTimeout(() => {
        const closedMapBuff = new Map(closedSnackbars);
        closedMapBuff.delete(uuid);
        setClosedSnackbars(closedMapBuff);
        removeSnackBar(uuid);
      }, 200);
    },
    [closedSnackbars, removeSnackBar],
  );

  return (
    <>
      {Array.from(snackbars).map(([uuid, data], index) =>
        index === 0 ? (
          <SnackBar
            key={uuid}
            {...data}
            onOpenChange={(o) => !o && handleClose(uuid)}
            open={!closedSnackbars.get(uuid)}
          />
        ) : null,
      )}
    </>
  );
};

export { GlobalSnackBars };
